import kay from '../assets/kay.png'

export const parseInteger = (int) => {
    return int?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

export const handleListingImageError = (event) => {
    event.target.src = 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80'; // Replace with your fallback image link   
}

export const handleAuctioneerImageError = (event) => {
    event.target.src = kay;
}